import { createFileRoute } from '@tanstack/react-router';
import { MemberSettings } from '@/features/projects/settings/member-settings';

export const Route = createFileRoute('/_app/p/$projectKey/settings/members')({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey } = Route.useParams();
  return <MemberSettings projectKey={projectKey} />;
}
